import * as Yup from 'yup';
import i18n from '../../utils/i18n.ts';
import { HomeOutlined } from '@ant-design/icons';

export const BREADCRUNBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
];

export const VALIDATION_SCHEMA = Yup.object().shape({
  title: Yup.string()
    .max(256, i18n.t('error.validation.max-256'))
    .required(i18n.t('error.validation.required-title')),
  titleEnglish: Yup.string().max(256, i18n.t('error.validation.max-256')),
  creationDate: Yup.string().required(i18n.t('error.validation.required-creation')),
  author: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required(i18n.t('error.validation.required-author')),
      }),
    )
    .nullable()
    .required(i18n.t('error.validation.required-author')),
  topics: Yup.array()
    .of(Yup.string().required(i18n.t('error.validation.required-topic'))) // each item must be non-empty
    .min(1, i18n.t('error.validation.required-topic')),
  unitInChargeId: Yup.string().required(i18n.t('error.validation.required-unit')),
  shortDescription: Yup.string()
    .required(i18n.t('error.validation.required-short-description'))
    .max(1500, i18n.t('error.validation.max-500')),
  shortDescriptionEnglish: Yup.string().max(1500, i18n.t('error.validation.max-500')),
});